import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection, LeadingTitle, LinkWithImage, Pagination } from "@components";
import "./AnalytistMeeting.scss";
import { ReportAPINew, ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const AnalytistMeeting = function () {
  const query = useQuery();
  const {t} = useTranslation();
  const [temuAnalisReport, setTemuAnalisReport] = useState({});
  const [shortDesc, setShortDesc] = useState(null);
  const page = query.get("page") || 1;

  useEffect(() => {
    const loadData = async function () {
      const filter = {
        cat: "temu_analis",
        orderBy: "desc",
        page: page,
      };
      const reportData = await ReportAPINew(queryString.stringify(filter)); 
      setTemuAnalisReport(reportData.data.data);
    };

    if (page) {
      loadData();
    }

    const loadShortDescData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "temu_analis" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadShortDescData();
    }
  }, [page, shortDesc]);

  const createPagination = () => {
    const { total, per_page } = temuAnalisReport;
    return {
      totalItems: total,
      currentPage: +page,
      limit: per_page,
    }
  }
  return (
    <InvestorContainer>
      <LeadingTitle
        title={t("presentasi_perusahaan")}
        subtitle={shortDesc !== null ? shortDesc[0].title : ""}     
      />
      <div className="analyst-meeting-content">
        <div className="card-box">
          {temuAnalisReport != null
            ? temuAnalisReport.result?.map((data, i) => {
                return (
                  <LinkWithImage
                    image={data.image}
                    title={data.title}
                    file={data.file}
                    key={i}
                  />
                );
              })
            : ""}
        </div>
        <nav className="pagination-box" aria-label="Page navigation example">
          <ul className="pagination">
            <Pagination {...createPagination()} />
          </ul>
        </nav>
      </div>

      <FooterSection currentPage={t("presentasi_perusahaan")}/>
    </InvestorContainer>
  );
};

export default AnalytistMeeting;
